module.exports = __webpack_public_path__ + "static/assets/619f7584233d9a517d7f73a4df7af66c.gif";